// extracted by mini-css-extract-plugin
export default {"overlay":"RotateDevicePrompt_overlay__n+pp5","messageContainer":"RotateDevicePrompt_messageContainer__hXi5I","message":"RotateDevicePrompt_message__3XaP4"};